module.exports = __webpack_public_path__ + "img/elemento_ramo_d.7b09fc39.png";